import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";
import { setStoredValue } from "../../src/_helpers/storageHelper";
// create slice

const name = "KioskDashboard";
const initialState = createInitialState();
const extraActions = createExtraActions();
const slice = createSlice({
    name,
    initialState,
    extraReducers: (builder) => {
        createExtraReducers(builder, extraActions);
    },
});

// exports

export const KioskDashboardActions = { ...slice.actions, ...extraActions };
export const KioskDashboardReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        LoadInmateMainMenuDetails: [],
    };
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;


    return {
        getLoadInmateMainMenu: getLoadInmateMainMenu()
    };


    function getLoadInmateMainMenu() {
        return createAsyncThunk(
            `${name}/getLoadInmateMainMenu`,
            async ({ inmateID, podCode }) =>
                await fetchWrapper.get(`${baseUrl}/kiosk/KioskDashboard/GetLoadInmateMainMenu?inmateID=${inmateID}&podCode=${podCode}`)
        );
    }

}

function createExtraReducers(builder, actions) {
    builder
        .addCase(actions.getLoadInmateMainMenu.pending, (state) => {
            state.LoadInmateMainMenuDetails = [];
        })
        .addCase(actions.getLoadInmateMainMenu.fulfilled, (state, action) => {
            state.LoadInmateMainMenuDetails = action.payload;
            setStoredValue("inmateMenuList", action.payload);
        })
        .addCase(actions.getLoadInmateMainMenu.rejected, (state, action) => {
            state.LoadInmateMainMenuDetails = { error: action.error };
        });
}
